import {Box, Text, Flex, Icon, Button, Image, useToast} from '@chakra-ui/react'
import Header from './Header'
import {ReactComponent as Target} from '@assets/svgs/roadmap/target.svg'
import Task from '../components/Task'
import {ReactComponent as ArrowRight} from '@assets/svgs/roadmap/arrow_right.svg'
import {useLocation, useNavigate} from 'react-router-dom'
import {useEffect, useRef, useState} from 'react'
import CupIcon from '@assets/svgs/roadmap/cup.svg'
import mapRequest from '@apis/map'
import Logo from '@assets/svgs/roadmap/logo.svg'
import MicIcon from '@assets/svgs/roadmap/mic.svg'
import Survey from './Survey'
import {useDispatch, useSelector} from 'react-redux'
import {EVENT_NAME, PATH, SCREEN_TRACKING} from '@utils/Const'
import {CommonColors} from '@utils/CommonStyles'
import {ReactComponent as FlagIcon} from '@assets/svgs/maps/flag_on.svg'
import Loading from '@components/Loading'
import {
  getFeedbackType,
  isParamsValid,
  trackingEvent,
  trackingPage,
} from '@utils'
import appRequest from '@apis/app'
import {
  updateEntryPointShowUpgradeModal,
  updateIsShowUpgradeModal,
} from '@redux/map/mapSlice'
import ArrowRightIcon from '@assets/svgs/learn/arrow_right_2.svg'
import CloseIcon from '@assets/svgs/close.svg'

const RoadmapSummary = () => {
  const [taskSummary, setTaskSummary] = useState<any>(null)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [isFinishWeek, setIsFinishWeek] = useState<boolean>(false)
  const [isSurveyed, setIsSurveyed] = useState<boolean>(false)
  const currentTaskRef = useRef<HTMLDivElement | null>(null)
  const {dataFeedbackOverview} = useSelector((state: any) => state.shared)
  const {task_id, feature_name} = useLocation()?.state || {}

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const toast = useToast()

  useEffect(() => {
    if (!isParamsValid([task_id])) {
      navigate(PATH.HOME)
    }
  }, [])

  useEffect(() => {
    if (!taskSummary) return
    if (taskSummary?.is_section_completed) {
      trackingEvent(SCREEN_TRACKING.ROADMAP_WEEK_SUMMARY, {
        week_name: taskSummary?.current_section?.section_name,
        lesson_name: taskSummary?.current_task?.task_name,
      })
    } else {
      trackingEvent(SCREEN_TRACKING.ROADMAP_LESSON_SUMMARY, {
        week_name: taskSummary?.current_section?.section_name,
        lesson_name: taskSummary?.current_task?.task_name,
      })
    }
  }, [taskSummary])

  useEffect(() => {
    if (!task_id) return
    getTaskSummary()
  }, [])

  useEffect(() => {
    if (isSurveyed) {
      checkIsShowPreOrder()
    }
  }, [isSurveyed])

  // Thông báo xem bài thi thử khi chấm xong
  useEffect(() => {
    if (!isSurveyed) return
    if (
      feature_name === 'MOCK_TEST_PART_ONE' ||
      feature_name === 'REAL_TEST_PART_ONE' ||
      feature_name === 'MOCK_TEST_PART_TWO' ||
      feature_name === 'REAL_TEST_PART_TWO'
    ) {
      const idToast1 = toast({
        position: 'bottom-left',
        isClosable: true,
        duration: 60000,
        render: () => (
          <Box
            p={'24px'}
            bg="white"
            position={'relative'}
            borderRadius={'16px'}
            boxShadow={
              '0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05)'
            }>
            <Image
              position={'absolute'}
              top={'24px'}
              right={'24px'}
              src={CloseIcon}
              cursor={'pointer'}
              w={'20px'}
              onClick={() => toast.close(idToast1)}
            />
            <Text fontSize={'16px'} fontWeight={600} mr={'30px'}>
              Bài thi của bạn đang được chấm điểm.
            </Text>
          </Box>
        ),
      })
      const idToast2 = toast({
        position: 'bottom-left',
        isClosable: true,
        duration: 60000,
        render: () => (
          <Box
            p={'24px'}
            pb={0}
            bg="white"
            borderRadius={'16px'}
            boxShadow={
              '0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05)'
            }>
            <Flex justifyContent={'end'}>
              <Image
                src={CloseIcon}
                cursor={'pointer'}
                w={'20px'}
                onClick={() => toast.close(idToast2)}
              />
            </Flex>
            <Flex gap={'16px'} fontSize={'16px'} fontWeight={600} mt={'16px'}>
              <Text>
                Đến Phòng thi vào "Bài nói của bạn" để xem kết quả sau 2-3 phút
                nhé
              </Text>
            </Flex>
            <Flex justifyContent={'flex-end'} alignItems={'center'}>
              <Flex
                gap={'10px'}
                cursor={'pointer'}
                onClick={() => {
                  navigate(PATH.EXAM_HISTORY)
                  toast.close(idToast1)
                  toast.close(idToast2)
                }}>
                <Text
                  fontSize={'16px'}
                  fontWeight={700}
                  color={'#1890FF'}
                  pt={'12px'}
                  pb={'24px'}>
                  Xem lại ngay
                </Text>
                <Image src={ArrowRightIcon} />
              </Flex>
            </Flex>
          </Box>
        ),
      })
    }
  }, [isSurveyed])

  useEffect(() => {
    if (taskSummary) {
      const feedbackType: any = getFeedbackType(
        taskSummary?.current_task?.task_type,
      )
      dataFeedbackOverview?.feedback_data[feedbackType]?.is_completed
        ? setIsSurveyed(true)
        : setIsSurveyed(false)
    }
  }, [taskSummary])

  useEffect(() => {
    setIsFinishWeek(taskSummary?.is_section_completed)
  }, [taskSummary])

  useEffect(() => {
    if (currentTaskRef.current) {
      currentTaskRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
    }
  }, [taskSummary, currentTaskRef, isSurveyed])

  const checkIsShowPreOrder = async () => {
    const res = await appRequest.checkIsShowPreOrder()
    if (res?.data?.data?.is_show_pre_order) {
      trackingPage(SCREEN_TRACKING.SALE_SCREEN_VIEW, {
        entry_point: 'roadmap_summary',
      })
      dispatch(updateIsShowUpgradeModal(true))
      dispatch(updateEntryPointShowUpgradeModal('roadmap_summary'))
    }
  }

  const getTaskSummary = async () => {
    try {
      const res = await mapRequest.getTaskSummary({
        task_id: task_id,
      })
      setTaskSummary(res.data.data)
    } catch (error) {
    } finally {
      setIsLoading(false)
    }
  }

  const handleClickBack = () => {
    if (isFinishWeek) {
      trackingEvent(EVENT_NAME.MAP_WEEK_SUMMARY_BACK_MAP)
    } else {
      trackingEvent(EVENT_NAME.MAP_LESSON_SUMMARY_BACK_MAP)
    }
    navigate(PATH.HOME, {replace: true})
  }

  if (isLoading) {
    return <Loading />
  }

  return (
    <Box>
      {!isSurveyed ? (
        <Flex
          p={{base: 4, md: 6}}
          alignItems="center"
          justifyContent="center"
          borderBottom="2px solid #E4E7EC">
          <Flex cursor={'pointer'} onClick={() => navigate(PATH.HOME)}>
            <Image src={MicIcon} alt="IELTS Coach Logo" mr={2} />
            <Image src={Logo} alt="IELTS Coach Logo" />
          </Flex>
        </Flex>
      ) : (
        <Header taskSummary={taskSummary} isFinishWeek={isFinishWeek} />
      )}
      {!isSurveyed ? (
        <Survey setIsSurveyed={setIsSurveyed} taskSummary={taskSummary} />
      ) : (
        <Box
          mt={
            isFinishWeek
              ? {base: '-200px', md: '-270px'}
              : {base: '0px', md: '-90px'}
          }
          p={{base: '16px', md: '32px'}}
          borderRadius={{base: '16px', md: '24px'}}
          bg={'#F9FAFB'}
          maxW={'900px'}
          mx={'auto'}>
          {isFinishWeek && (
            <Flex flexDirection={'column'} alignItems={'center'}>
              <Text fontSize={{base: '20px', md: '24px'}} fontWeight={700}>
                Siêu Cao Thủ
              </Text>
              <Text fontSize={{base: '14px', md: '16px'}} textAlign="center">
                Bạn đã master được bài học tuần này rồi đó!
              </Text>
              <Image
                src={CupIcon}
                alt="cup-icon"
                w={'120px'}
                h={'120px'}
                mt={'16px'}
              />
              <Flex alignItems={'center'} gap={'8px'} mt={'16px'}>
                <Icon as={Target} stroke={'#339CFF'} />
                <Text
                  textTransform={'uppercase'}
                  fontSize={'12px'}
                  fontWeight={700}
                  color={'#667085'}>
                  {taskSummary?.current_section?.section_name}
                </Text>
              </Flex>
              <Text fontSize={'18px'} fontWeight={600}>
                {taskSummary?.current_section?.section_title}
              </Text>
              <Flex justifyContent={'end'} w={'100%'} mt={'16px'}>
                <Icon
                  as={FlagIcon}
                  w={'30px'}
                  h={'30px'}
                  transform="scaleX(-1)"
                />
              </Flex>
              <Flex w={'100%'} gap={'4px'} mt={'8px'}>
                {Array.from({
                  length:
                    taskSummary?.section_summary?.current_section_total_task,
                }).map((_, index) => (
                  <Box
                    key={index}
                    flex={1}
                    h={'10px'}
                    borderRadius={'4px'}
                    bg={CommonColors.primary}
                  />
                ))}
              </Flex>
              <Flex justifyContent={'end'} w={'100%'} mt={'8px'}>
                <Text fontSize={'14px'} color={'#667085'}>
                  Hoàn thành{' '}
                  {taskSummary?.section_summary?.current_section_total_task ||
                    0}{' '}
                  bài học
                </Text>
              </Flex>
            </Flex>
          )}
          <Box
            p={isFinishWeek ? {base: '16px', md: '32px'} : '0px'}
            mt={isFinishWeek ? {base: '16px', md: '32px'} : '0px'}
            border={isFinishWeek ? '2px solid #E4E7EC' : 'none'}
            borderRadius={isFinishWeek ? {base: '16px', md: '24px'} : '0px'}>
            <Flex
              gap={{base: '20px', md: '40px'}}
              alignItems={'center'}
              flexDirection={{base: 'column', md: 'row'}}>
              <Box maxW={isFinishWeek ? 'unset' : {base: '100%', md: '300px'}}>
                <Flex alignItems={'center'} gap={'8px'}>
                  <Icon as={Target} stroke={'#339CFF'} />
                  <Text
                    textTransform={'uppercase'}
                    fontSize={'12px'}
                    fontWeight={700}
                    color={'#667085'}>
                    {isFinishWeek
                      ? taskSummary?.section_summary?.next_section
                          ?.next_section_heading?.section_name
                      : taskSummary?.current_section?.section_name}
                  </Text>
                </Flex>
                <Text fontSize={'18px'} fontWeight={600}>
                  {isFinishWeek
                    ? taskSummary?.section_summary?.next_section
                        ?.next_section_heading?.section_title
                    : taskSummary?.current_section?.section_title}
                </Text>
                {isFinishWeek && (
                  <Text>
                    {
                      taskSummary?.section_summary?.next_section
                        ?.next_section_heading?.description
                    }
                  </Text>
                )}
              </Box>
              {!isFinishWeek && (
                <Flex
                  flex={1}
                  flexDirection={'column'}
                  w={{base: '100%', md: 'unset'}}>
                  <Flex justifyContent={'end'} w={'100%'} mt={'16px'}>
                    <Icon
                      as={FlagIcon}
                      w={'30px'}
                      h={'30px'}
                      transform="scaleX(-1)"
                    />
                  </Flex>
                  <Flex w={'100%'} gap={'4px'} mt={'8px'}>
                    {Array.from({
                      length: taskSummary?.task_summary?.number_total_tasks,
                    }).map((_, index) => (
                      <Box
                        key={index}
                        flex={1}
                        h={'10px'}
                        borderRadius={'4px'}
                        bg={
                          index <
                          taskSummary?.task_summary?.number_completed_tasks
                            ? CommonColors.primary
                            : '#E4E7EC'
                        }
                      />
                    ))}
                  </Flex>
                  <Flex justifyContent={'end'} w={'100%'} mt={'8px'}>
                    <Text fontSize={'14px'} color={'#667085'}>
                      {`Hoàn thành ${taskSummary?.task_summary?.number_completed_tasks} / ${taskSummary?.task_summary?.number_total_tasks} bài học`}
                    </Text>
                  </Flex>
                </Flex>
              )}
            </Flex>
            <Flex
              className="scroll-bar task-list"
              mt={'24px'}
              flexDirection={'column'}
              gap={'14px'}
              maxH={{base: '400px', md: '322px'}}
              overflowY={'auto'}>
              {isFinishWeek ? (
                <>
                  {taskSummary?.section_summary?.next_section?.tasks?.map(
                    (taskItem: any, index: number) => (
                      <Task
                        key={index}
                        index={index}
                        week_name={''}
                        is_summary={true}
                        is_lock={taskItem?.is_lock}
                        image={taskItem?.image}
                        task_id={taskItem?.id}
                        type={taskItem?.type}
                        input_params={taskItem?.input_params}
                        title={taskItem?.name}
                        duration={`${taskItem?.estimate_time} min`}
                        status={'current'}
                        is_finish_week={isFinishWeek}
                        is_course_available={true}
                      />
                    ),
                  )}
                </>
              ) : (
                <>
                  {taskSummary?.task_summary?.tasks?.map(
                    (taskItem: any, index: number) => (
                      <Task
                        ref={
                          taskItem?.id ===
                          taskSummary?.task_summary?.max_task_id
                            ? currentTaskRef
                            : null
                        }
                        key={index}
                        index={index}
                        week_name={''}
                        is_summary={true}
                        is_finish_week={isFinishWeek}
                        is_lock={taskItem?.is_lock}
                        image={taskItem?.image}
                        task_id={taskItem?.id}
                        type={taskItem?.type}
                        input_params={taskItem?.input_params}
                        title={taskItem?.name}
                        duration={`${taskItem?.estimate_time} min`}
                        status={
                          taskItem?.is_completed
                            ? 'completed'
                            : taskItem?.id ===
                                taskSummary?.task_summary?.max_task_id
                              ? 'current'
                              : taskItem?.task_order >
                                  taskSummary?.task_summary?.max_task_order
                                ? 'locked'
                                : undefined
                        }
                        is_course_available={true}
                      />
                    ),
                  )}
                </>
              )}
            </Flex>
          </Box>
          <Flex mt={'24px'} justifyContent={{base: 'center', md: 'flex-start'}}>
            <Button
              w={{base: '100%', md: 'auto'}}
              bg="white"
              color="#344054"
              fontWeight="bold"
              py={6}
              px={6}
              borderRadius="12px"
              border="1px solid #D0D5DD"
              transition="all 0.3s"
              display="flex"
              alignItems="center"
              justifyContent="center"
              onClick={handleClickBack}>
              <Icon
                as={ArrowRight}
                mr={2}
                w={'20px'}
                h={'20px'}
                transform="rotate(180deg)"
              />
              <Text fontSize="16px" fontWeight="600">
                Quay lại lộ trình
              </Text>
            </Button>
          </Flex>
        </Box>
      )}
    </Box>
  )
}

export default RoadmapSummary
